// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkText_link__Ql2NP","sending":"LinkText_sending__2ZtA3"};